import { http } from '../../config/axios'

export default function getFaturaDownload(id:string) :Promise<Blob>{
    return http.get('/api/fatura/imprimir/' + id, {
        responseType: 'blob'
    })
    .then((r) => r.data)
    .then((blobFile) => {
        return blobFile
    })
    .catch((error) => {
        console.error('Erro ao getFaturaDownload')
        return new Blob()
    })
}